<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__top">
        <div class="footer__brand">
          <div class="footer__logo">
            <span class="footer__logo-icon">智</span>
            <span>{{ company.fullName }}</span>
          </div>
          <p class="footer__slogan">专注智慧政务解决方案 助力治理能力现代化</p>
        </div>

        <div class="footer__links">
          <div class="footer__col">
            <h4>产品服务</h4>
            <ul>
              <li v-for="p in products" :key="p.id">
                <router-link v-if="p.route" :to="p.route">{{ p.title }}</router-link>
                <router-link v-else to="/products">{{ p.title }}</router-link>
              </li>
            </ul>
          </div>
          <div class="footer__col">
            <h4>关于我们</h4>
            <ul>
              <li><router-link to="/about">公司简介</router-link></li>              
              <li><router-link :to="contactLink">联系我们</router-link></li>
            </ul>
          </div>
          <div class="footer__col">
            <h4>联系我们</h4>
            <ul>
              <li>{{ company.address }}</li>
              <li>{{ company.phone }}</li>
              <li>{{ company.email }}</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <p>
          CopyRight © {{ company.copyright }} {{ company.fullName }}版权所有
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{ company.icp }}</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import { company, products } from '../data/site'

export default {
  name: 'TheFooter',
  data() {
    return { company, products }
  },
  computed: {
    contactLink() {
      if (this.$route.path === '/cadre-management') {
        return { path: '/cadre-management', hash: '#contact' }
      }
      return '/contact'
    }
  }
}
</script>

<style scoped>
.footer {
  background: #0d1b2a;
  color: rgba(255, 255, 255, 0.75);
  padding: 60px 0 0;
}

.footer__top {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 48px;
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer__logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 12px;
}

.footer__logo-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0052d9, #00a3ff);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
}

.footer__slogan {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

.footer__links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}

.footer__col h4 {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
}

.footer__col li {
  font-size: 13px;
  margin-bottom: 10px;
  line-height: 1.5;
}

.footer__col a:hover {
  color: #00a3ff;
}

.footer__bottom {
  padding: 20px 0;
  text-align: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.footer__bottom a {
  margin-left: 8px;
}

.footer__bottom a:hover {
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .footer__top {
    grid-template-columns: 1fr;
  }

  .footer__links {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
